import React from 'react';
import { useTheme } from '@emotion/react';
// Mui components
import { Box, Modal } from '@mui/material';

function SmallModalContainer({ children, open, onClose }) {
    const theme = useTheme();

    const cardStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: "50%",
        maxWidth: "450px",
        padding: "2.5rem",
        bgcolor: theme.palette.white.main,
        borderRadius: "16px"
    };


    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={cardStyle}>
                {children}
            </Box>
        </Modal>
    );
}

export default SmallModalContainer;